import { Component } from '@theme/component';

class EscMobileFilters extends Component {
  requiredRefs = ['mobileFiltersForm'];

  #previousScrollY = 0;

  connectedCallback() {
    super.connectedCallback();

    this.#addSubmitListner();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  #addSubmitListner() {
    this.refs.mobileFiltersForm.addEventListener('submit', (event) => {
      event.preventDefault();
      this.#applyFilters();
    })
  }

  open() {
    this.classList.add('esc-mobile-filters--open');
    this.#lockBodyScroll();
  }

  close() {
    this.classList.remove('esc-mobile-filters--open');
    this.#unlockBodyScroll();
  }

  #lockBodyScroll() {
    const scrollY = window.scrollY;
    this.#previousScrollY = scrollY;

    requestAnimationFrame(() => {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
    });
  }

  #unlockBodyScroll() {
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: this.#previousScrollY, behavior: 'instant' });
  }

  #applyFilters() {
    const formData = new FormData(this.refs.mobileFiltersForm);
    const urlParameters = new URLSearchParams(formData);

    const url = new URL(window.location.pathname, window.location.origin);

    for (const [key, value] of urlParameters) url.searchParams.append(key, value);

    for (const value of urlParameters.values()) {
      console.log(value);
    }

    fetch(url)
      .then((response) => response.text())
      .then((responseHTML) => {
        this.#updateResults(responseHTML);
        this.#updateURLParameters(urlParameters);
        this.close();
      })
  }

  #updateResults(responseHTML) {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = responseHTML;

    const selector = `.esc-collection__products[data-section-id=${this.sectionId}]`;

    const newProductsElement = wrapper.querySelector(selector);
    const productsElement = document.querySelector(selector);

    if (productsElement && newProductsElement) {
      productsElement.innerHTML = newProductsElement.innerHTML;
    }
  }

  #updateURLParameters(urlParameters) {
    const url = new URL(window.location.href);

    url.search = '';
    for (const [param, value] of urlParameters.entries()) {
      url.searchParams.append(param, value);
    }

    history.pushState({ urlParameters: urlParameters.toString() }, '', url.toString());
  }
}

if (!customElements.get('esc-mobile-filters')) {
  	customElements.define('esc-mobile-filters', EscMobileFilters);
}